module.exports = __webpack_public_path__ + "media/images/athletes/1781-513cba89b03c513993e480db2bcd51c6.png";